import { ActiveActivityId, ROUTE_NAME } from '@/lib/constant';
import { getQS } from '@/lib/utils';
import Loading from '@/pages/extra/loading.vue';
import { Route } from 'vue-router';
import { component } from 'vue/types/umd';

let newPagesId = [60, 62]
// let newPagesId = [47, 48]
console.log('process.env.RO_ENV', process.env.RO_ENV)
if(process.env.RO_ENV === 'development') {
    // newPagesId = [47, 48]
}

export default [
    {
        path: '/activity/member_monitor_list/:type', // 活动id
        name: ROUTE_NAME.ACTIVITY_MEMBER_MONITOR,
        meta: {
            title(to: Route) {
                return to.params.type === 'member' ? '队员列表' : '队长列表';
            },
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/memberMonitorList.vue'),
    },
    {
        // path: '/activity_o/list',
        // name: ROUTE_NAME.ACTIVITY_LIST_O,
        path: '/activity/list',
        alias: '/',
        name: ROUTE_NAME.ACTIVITY_LIST,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/list.vue'),
    },
    {
        // path: '/activity/list',
        // alias: '/',
        // name: ROUTE_NAME.ACTIVITY_LIST,
        path: '/activity_o/list',
        name: ROUTE_NAME.ACTIVITY_LIST_O,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
        },
        // component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/list.vue'),
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/home.vue'),
    },
    {
        path: '/activity/detail/:activityId',
        name: ROUTE_NAME.ACTIVITY_DETAIL,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needLogin: true
        },
        beforeEnter(to, form, next) {
            const activityId = to.params.activityId;
            // newPagesId.includes(+activityId!)
            if(+activityId > 60) {
                next({
                    name: ROUTE_NAME.ACTIVITY_DETAIL_24,
                    params: {
                        activityId
                    }
                })
            } else {
                next()
            }
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/detail.vue'),
    },
    {
        path: '/activity_detail_24/:activityId?',
        name: ROUTE_NAME.ACTIVITY_DETAIL_24,
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/detail24.vue'),
    },
    {
        path: '/activity/package/:activityId',
        name: ROUTE_NAME.ACTIVITY_PACKAGE,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needLogin: true,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/package.vue'),
    },
    {
        path: '/activity/skus/:activityId',
        name: ROUTE_NAME.ACTIVITY_SKUS,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needLogin: true,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/skus.vue'),
    },
    {
        path: '/activity/result/:activityId',
        name: ROUTE_NAME.ACTIVITY_RESULT,
        meta: {
            title: '百日跑',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needLogin: true,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/result.vue'),
    },
    {
        path: '/activity/other/pay',
        name: ROUTE_NAME.ACTIVITY_OTHER,
        meta: {
            title: '代付款',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/otherPay.vue'),
    },
    {
        path: '/activity/deposit/:activityId/:levelId?',
        name: ROUTE_NAME.ACTIVITY_DEPOSIT,
        meta: {
            title: '契约金',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        beforeEnter(to, from, next) {
            const activityId = to.params.activityId;
            if(activityId === '54') {
                next({
                    name: 'deposit_23',
                })
            } else {
                next()
            }
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/deposit.vue'),
    },
    {
        path: '/activity/deposit_23/:activityId/:levelId?',
        name: 'deposit_23',
        meta: {
            title: '契约金',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/deposit_23.vue'),
    },
    {
        path: '/activity/deposit_history/:activityId',
        name: ROUTE_NAME.ACTIVITY_DEPOSIT_HISTORY,
        meta: {
            title: '契约金明细',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/depositHistory.vue'),
    },
    {
        path: '/activity/previous',
        name: ROUTE_NAME.ACTIVITY_PREVIOUS,
        meta: {
            title: '全部赛事',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needLogin: true,
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/previous.vue'),
    },
    {
        path: '/activity/1',
        name: ROUTE_NAME.ACTIVITY_10,
        meta: {
            title: '首页',
            popup: 'countdown',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/activity10.vue'),
    },
    {
        path: '/activity/2',
        name: ROUTE_NAME.ACTIVITY_11,
        meta: {
            title: '首页',
            popup: 'countdown',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/activity11.vue'),
    },
    {
        path: '/activity/3',
        name: ROUTE_NAME.ACTIVITY_12,
        meta: {
            title: '首页',
            popup: 'countdown',
            scrollBehavior: 'top',
        },
        component: () => import(/* webpackChunkName: "activity" */ '@/pages/activity/activity12.vue'),
    },
    {
        // tip: 如果使用/activity/:activityId作为path，那么alias将永远不会被match到
        alias: '/activity/:activityId?',
        path: '/activity/index/:activityId?/:activitySpecialId?',
        name: ROUTE_NAME.ACTIVITY,
        meta: {
            title: '报名',
            popup: 'countdown',
            scrollBehavior: 'top',
            needLogin: true,
        },
        beforeEnter(to: Route, from: Route, next: any) {
            // 跳转到不同的页面
            const activityId = to.params.activityId || getQS().activity_id as string;
            const map: { [id: string]: string | boolean } = {
                1: ROUTE_NAME.ACTIVITY_10,
                // @ts-nocheck
                2: ROUTE_NAME.ACTIVITY_11,
                // @ts-nocheck
                3: ROUTE_NAME.ACTIVITY_12,
            };
            const name = map[activityId];
            if (name) {
                // todo: to是readonly的?
                next({
                    name: map[activityId],
                    params: to.params,
                });
            } else if (name === false) {
                next(false);
            } else {
                next();
            }
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/activity13.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/equipment_o/:activityId?/:orderId?', // :from?放到query 如果不是从邀请卡页面进入，返回战队详情页
        name: ROUTE_NAME.ACTIVITY_EQUIPMENT_O,
        meta: {
            title: '收货地址',
            needBinding: true,
            disableShare: true,
            scrollBehavior: 'top',
            needLoginNext: true,
            activityForceUpdate: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/equipment.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/equipment/:activityId?/:orderId?', // :from?放到query 如果不是从邀请卡页面进入，返回战队详情页
        name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
        meta: {
            title: '订单',
            needBinding: true,
            disableShare: true,
            scrollBehavior: 'top',
            needLoginNext: true,
            activityForceUpdate: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/equipmentNew.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/news/:activityId',
        name: ROUTE_NAME.ACTIVITY_NEWS,
        meta: {
            title: '最新战报',
            scrollBehavior: 'top',
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/news.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/runners/:activityId',
        name: ROUTE_NAME.ACTIVITY_RUNNERS,
        meta: {
            title: '报名人数',
            scrollBehavior: 'top',
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/runners.vue'),
        }),
    },
    {
        path: '/activity/search/:activityId/:activitySpecialId?',
        name: ROUTE_NAME.ACTIVITY_SEARCH,
        meta: {
            title: '搜索',
            scrollBehavior: 'top',
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/search.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/tips/:activityId',
        name: ROUTE_NAME.ACTIVITY_TIPS,
        meta: {
            title: '锦囊',
            needBinding: true,
            scrollBehavior: 'top',
            disableShare: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/tips.vue'),
            loading: Loading,
        }),
    },
    // 兼容存在type的情况
    {
        path: '/activity/submit/order/:activityId/:teamId/:type', // 战队Id, 类型包括两种 upgrade/pay
        redirect(to: Route) {
            return {
                name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
                params: to.params,
            };
        },
    },
    // 提交订单
    {
        path: '/activity/submit/order/:activityId/:teamId?', // 活动id 战队Id
        name: ROUTE_NAME.ACTIVITY_SUBMIT_ORDER,
        meta: {
            title: '报名详情',
            disableShare: true,
            scrollBehavior: 'top',
            needLogin: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/submitOrder.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/pay/finished/:activityId/:teamId?', // 战队Id，类型包括两种 upgrade/pay
        name: ROUTE_NAME.ACTIVITY_PAY_FINISHED,
        meta: {
            title: '规格地址',
            needBinding: true,
            disableShare: true,
            scrollBehavior: 'top',
        },
        beforeEnter(to: Route, from: Route, next: any) {
            const activityId = Number(to.params.activityId);
            if (activityId >= 3) {
                next({
                    name: ROUTE_NAME.ACTIVITY_EQUIPMENT,
                    params: to.params,
                    query: to.query,
                });
            } else if (activityId <= 2) {
                next(false);
            }
        },
    },
    {
        path: '/activity/question/:activityId', // 报名疑问
        name: ROUTE_NAME.ACTIVITY_QUESTION,
        meta: {
            title: '疑问',
            needBinding: true,
            disableShare: true,
            scrollBehavior: 'top',
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/question.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/refund/:activityId', // 报名疑问
        name: ROUTE_NAME.ACTIVITY_REFUND,
        meta: {
            title: '退赛退款',
            disableShare: true,
            scrollBehavior: 'top',
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/refund.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/category/:categoryId/:activityId?',
        name: ROUTE_NAME.ACTIVITY_CATEGORY,
        meta: {
            title: '答疑解惑',
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "feedback" */ '@/pages/activity/category.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/select_team/:activityId/:activitySpecialId?', // 活动id
        name: ROUTE_NAME.ACTIVITY_SELECT_TEAM,
        meta: {
            title: '选择战队',
            needBinding: true,
        },
        component: () => ({
            // component: import(/* webpackChunkName: "activity" */ '@/pages/activity/selectTeam.vue'),
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/newSelectTime.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/select_team1/:activityId/:activitySpecialId?', // 活动id
        name: ROUTE_NAME.ACTIVITY_SELECT_TEAM1,
        meta: {
            title: '选择战队',
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/selectTeam.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/activity/confirm_medal/:activityId', // 活动id
        name: ROUTE_NAME.ACTIVITY_CONFIRM_MEDAL,
        meta: {
            title: '确认收货地址',
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "activity" */ '@/pages/activity/confirmMedal.vue'),
            loading: Loading,
        }),
    },
    // 海报页
    {
      path: '/activity/loversRunPoster/:activityId', // 活动id
      name: ROUTE_NAME.LOVER_RUN_POSTER,
      meta: {
          title: '21届百日跑专题活动',
          needBinding: true,
      },
      component: () => ({
          component: import(/* webpackChunkName: "activity" */ '@/pages/activity/loversRunPoster.vue'),
          loading: Loading,
      }),
  },
];
